<template>
    <div>
        <div class="smallContent miscContent">

            <template v-if="!submitted">

                <p id="title">
                    Submit Programming Proposal
                    <br />
                </p>
                <form @submit.prevent="submit">
                    <input type="text" :class="{ invalid: isInvalid('name') }" v-model="form.name"
                        @focusout="validate(true, 0, 'name')" placeholder="Artist/Organization Name(s)" />

                    <input type="email" :class="{ invalid: isInvalid('email') }" v-model="form.email"
                        @focusout="validate(true, 0, 'email')" placeholder="E-mail address" />

                    <textarea v-model="form.description" :class="{ invalid: isInvalid('description') }"
                        @focusout="validate(true, 250, 'description')"
                        placeholder="Short Description of Segment (250 words maximum)"></textarea>

                    <textarea v-model="form.bio" :class="{ invalid: isInvalid('bio') }"
                        @focusout="validate(true, 250, 'bio')"
                        placeholder="Artist/Organization Bio(s) (250 words maximum)"></textarea>

                    <textarea v-model="form.links"
                        placeholder="Links to websites, examples of relevant work, and social media (optional)"></textarea>

                    <div class="inputTitle">Please select the format of your show:</div>
                    <div class="radioInput" :class="{ invalid: isInvalid('format') }">
                        <input type="radio" id="talk" value="ta" name="format" v-model="form.format"
                            @change="validate(true, 0, 'format')" />
                        <label for="talk">
                            <div class="labelImage"></div>
                            <span>Live talk show</span>
                        </label>

                        <input type="radio" @change="validate(true, 0, 'format')" id="performance" value="pe"
                            name="format" v-model="form.format" />
                        <label for="performance">
                            <div class="labelImage"></div>
                            <span>Live performance (music, public reading, other)</span>
                        </label>

                        <input type="radio" @change="validate(true, 0, 'format')" id="recorded" value="re" name="format"
                            v-model="form.format" />
                        <label for="recorded">
                            <div class="labelImage"></div>
                            <span>Pre-recorded show (sent as MP3)</span>

                        </label>

                        <input type="radio" @change="validate(true, 0, 'format')" id="broadcast" value="br"
                            name="format" v-model="form.format" />
                        <label for="broadcast">
                            <div class="labelImage"></div>
                            <span>Live broadcast from another space</span>

                        </label>
                    </div>


                    <template v-if="form.format == 'ta' || form.format == 'pe'">

                        <div class="inputTitle">Where will your live event take place:</div>
                        <div class="radioInput">
                            <input type="radio" id="ny" value="ny" name="location" v-model="form.location" />
                            <label for="ny">
                                <div class="labelImage"></div>
                                <span>New York</span>
                            </label>
                            <input type="radio" id="lo" value="lo" name="location" v-model="form.location" />
                            <label for="lo">
                                <div class="labelImage"></div>
                                <span>London</span>
                            </label>
                            <input type="radio" id="mx" value="mx" name="location" v-model="form.location" />
                            <label for="mx">
                                <div class="labelImage"></div>
                                <span>Mexico</span>
                            </label>
                            <input type="radio" id="ot" value="ot" name="location" v-model="form.location" />
                            <label for="ot">
                                <div class="labelImage"></div>
                                <span>Other</span>
                            </label>
                        </div>
                    </template>

                    <div class="inputTitle">Your proposal is a:</div>
                    <div class="radioInput" :class="{ invalid: isInvalid('type') }">
                        <input type="radio" id="series" value="se" name="type" v-model="form.type"
                            @change="validate(true, 0, 'type')" />
                        <label for="series">
                            <div class="labelImage"></div>
                            <span>Series</span>
                        </label>

                        <input type="radio" @change="validate(true, 0, 'type')" id="single" value="si" name="type"
                            v-model="form.type" />
                        <label for="single">
                            <div class="labelImage"></div>
                            <span>Single Segment</span>
                        </label>
                    </div>

                    <textarea v-model="form.equipment" placeholder="Equipment Needed (if live)"></textarea>
                    <textarea v-model="form.date" :class="{ invalid: isInvalid('date') }"
                        @focusout="validate(true, 0, 'date')"
                        placeholder="Preferred broadcast date/window (new segments generally air during the last week of every month)"></textarea>
                    <div class="inputTitle">Are your dates flexible?</div>
                    <div class="radioInput" :class="{ invalid: isInvalid('flexible') }">
                        <input type="radio" id="dateyes" value="ye" name="date" v-model="form.flexible"
                            @change="validate(true, 0, 'flexible')" />
                        <label for="dateyes">
                            <div class="labelImage"></div>
                            <span>Yes</span>
                        </label>

                        <input type="radio" @change="validate(true, 0, 'flexible')" id="dateno" value="no" name="date"
                            v-model="form.flexible" />
                        <label for="dateno">
                            <div class="labelImage"></div>
                            <span>No</span>
                        </label>
                    </div>
                    <textarea v-model="form.shared" :class="{ invalid: isInvalid('shared') }"
                        @focusout="validate(true, 0, 'shared')"
                        placeholder="Has the proposed work been shared or published on other platforms? If so, how will this broadcast or event expand upon its prior distribution?"></textarea>
                    <p>If you are an arts organization hoping to collaborate on a partnership, please complete the
                        above,
                        including budget and scope in the description, or send us an email to <a
                            href="mailto:radio@montezpress.com">radio@montezpress.com</a> with
                        more details.</p>

                    <input type="submit" value="Submit">
                    <div v-if="Object.keys(validators).find(k => validators[k] == false) && trySubmit"
                        id="errorMessage">
                        Please correct the errors above
                    </div>


                </form>
            </template>
            <template v-else>
                <p id="title">Thank you for submitting your proposal! We endeavor to respond to all queries as quickly
                    as possible, but due to the quantity of proposals we receive, we are unable to respond to every
                    submission.</p>
            </template>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
import axios from "axios";
export default {
    name: "Proposal",
    components: {
        Footer,
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                description: '',
                bio: '',
                links: '',
                format: '',
                location: '',
                type: '',
                equipment: '',
                date: '',
                flexible: '',
                shared: '',
            },
            validators: {
                name: false,
                email: false,
                description: false,
                bio: false,
                format: false,
                type: false,
                date: false,
                flexible: false,
                shared: false,
            },
            submitted: false,
            trySubmit: false,

        };
    },
    methods: {
        isInvalid(key) {
            if (this.trySubmit && this.validators[key] != true) {
                return true
            } else {
                return false
            }

        },
        countWords(str) {
            return str.trim().split(/\s+/).length;
        },
        validate(required, max, key) {
            let invalid = false
            if (required == true) {
                if (!this.form[key]) {
                    invalid = true
                } else {
                    invalid = false

                }
            }
            if (max != 0) {
                if (this.countWords(this.form[key]) > max) {
                    invalid = true
                }
            }
            if (invalid == true) {
                this.validators[key] = false
            } else {
                this.validators[key] = true
            }
        },

        submit() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            if (!Object.keys(this.validators).find(k => this.validators[k] == false)) {
                axios
                    .post("/api/add-proposal", {
                        form: myself.form
                    })
                    .then(function (response) {
                        if (response.data.message == "success") {
                            myself.submitted = true
                        } else {
                            console.log(response.data)
                        }

                    })
            } else {
                this.trySubmit = true
            }



        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
    },
    deactivated() {
        this.submitted = false;
        this.form = {
            name: '',
            email: '',
            description: '',
            bio: '',
            links: '',
            format: '',
            location: '',
            type: '',
            equipment: '',
            date: '',
            flexible: '',
            shared: '',
        }

        this.validators = {
            name: false,
            email: false,
            description: false,
            bio: false,
            format: false,
            type: false,
            date: false,
            flexible: false,
            shared: false,
        }
        this.trySubmit = false
    }
};
</script>

<style scoped>
p {
    margin: 0;
}

a {
    color: #aaaaaa;
    cursor: pointer;
}

a:hover {
    color: black;
}

.seperator {
    padding: 0.7rem 1rem 0.8rem;
    /* border-bottom: 1px solid black; */
    /* width: calc(100% - 2rem); */
}

#title {
    margin-bottom: 2rem;
}

form>* {
    margin-bottom: 1rem;
    margin-top: 0
}

input[type="text"].invalid,
textarea.invalid {
    border: 1px solid red;

}

input[type="text"],
textarea {
    width: 100%;
}


input[type="radio"] {
    width: auto;
    margin: 0;
}

.radioInput {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.radioInput.invalid {
    color: red;
}

.radioInput>label {
    flex-basis: 95%;
    flex-grow: 1;
}

.inputTitle {
    flex-basis: 100%;
}

input[type="radio"] {
    display: none;
}

label {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: flex-start;
    cursor: pointer;
}

input[type="radio"]+label>.labelImage {
    background: url("../assets/check-box.svg") no-repeat;
    height: 1.9rem;
    width: 1.9rem;
    background-size: 100%;
}

input[type="radio"]:checked+label>.labelImage {
    background: url("../assets/check-box-checked.svg") no-repeat;
}

#errorMessage {
    color: red;
}
</style>
